import $ from 'jquery';
import { getServices, getActiveServices } from '../../../../apis/marketPlace';
import { FREE_SEARCH_SERVICES } from '../constants';

export default {
  methods: {
    /**
     * store activate services and their respective ID's in an obj to use later for checking service is active or not
     * store all services and their respective ID's in an obj to use later for checking service is active or not
     */
    async setServices(isGloablSearchHomePage = false) {
      const allServices = await getServices();
      const activeServices = await getActiveServices(
        localStorage.getItem('accountId')
      );
      const map = new Map(
        activeServices.services.map((serviceId, index) => [serviceId, index])
      );
      this.activeServicesWithIdAsIdentifier = allServices.reduce(
        (acc, serviceInfo) => {
          if (map.has(serviceInfo.id)) acc[serviceInfo.name] = serviceInfo.id;
          return acc;
        },
        {}
      );
      this.servicesWithIdAsIdentifier = allServices.reduce(
        (acc, serviceInfo) => {
          acc[serviceInfo.name] = serviceInfo.id;
          return acc;
        },
        {}
      );
      if (isGloablSearchHomePage) {
        const restrictedServices = [2, 4];
        const currentlyShowingActiveServices = allServices?.filter(
          (serviceInfo) => restrictedServices.includes(serviceInfo.id)
        );
        currentlyShowingActiveServices.push({
          name: 'Regulations & Guidance'
        });
        this.servicesList = currentlyShowingActiveServices;
      }
    },
    getRouteName(service) {
      switch (service) {
        case 'Regulatory FAQs':
          return 'Faq';
        case 'Regulatory Process Charts':
          return 'RegulatoryProcessCharts';
        case 'Regulatory Watch':
          return 'RegulatoryUpdates';
        case 'Government Fee Finder':
          return 'GlobalFeeFinder';
        case 'Guides and Templates':
          return 'GuidesAndTemplates';
        case 'FDA Product Classification Lookup':
          return 'Classification';
        case '510 (K) Review Time Calculator':
          return 'ReviewTimeCalculator';
        case 'Marketplace':
          return 'service';
        case 'Agreements':
          return 'AgreementsView';
        case 'Product Tracker':
          return 'ProductTracker';
        case 'Records':
          return 'Registration';
        case 'Notifications':
          return 'notification';
        case 'Regulatory Reports':
          return 'RegulatoryPathway';
        case 'Dashboard':
          return 'Dashboard';
        case 'Smart Builder':
          return 'SubmissionBuilder';
        case 'Product Classification':
          return 'ProdClassification';
        default:
          return 'RegsAndGuidance';
      }
    },
    navigateIfServiceHasAccess(mappedServiceName, currentService, serviceInfo) {
      if (
        this.activeServicesWithIdAsIdentifier[mappedServiceName] ||
        FREE_SEARCH_SERVICES.includes(currentService)
      ) {
        const countryName = serviceInfo.country || serviceInfo.country_name;
        if (currentService === 'Marketplace' && +serviceInfo.id === 9) {
          window.open('https://www.emergobyul.com/opus', '_blank');
        } else {
          const routeName = this.getRouteName(currentService);
          this.$router
            .push({
              name: routeName,
              params: {
                search: this.$route.query.searchTerm,
                [currentService === 'Regulatory FAQs'
                  ? 'country'
                  : 'countryName']: countryName,
                serviceId: serviceInfo.id,
                service: currentService
              }
            })
        }
      } else {
        $('#modal_unsubscribed_market').modal({
          backdrop: 'static',
          keyboard: false
        });
      }
    }
  }
};
